<ngx-loading-bar [color]="'#ffcc00'" [height]="'5px'">
  <div class="loader-div"></div>
</ngx-loading-bar>
<div class="mat-drawer-container">
  <router-outlet></router-outlet>
</div>
